module.exports = __webpack_public_path__ + "static/media/do-illustration.0721738e.png";